import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import MUITable from "../../../../Common/MUITable";
import Loader from "../../../../Common/Loader/loader";
import isGHMC, { formatDateTimeWithoutSec, getCurrentDateTime } from "../../../../Common/helper/helpar";
import { MSWManagementVehiclesFilter } from "./MSWManagementVehiclesFilter";
import MSWManagementSecondaryCollectionStore from "./store/MSWManagementSecondaryCollectionStore";
import { MSWManagementVehiclesExport } from "./MSWManagementVehiclesExport";
import TableSkeleton from "../../../AllotedMaster/TableSkeleton";

export const MSWManagementVehiclesOnRoad = () => {
  const {
    fetchMSWManagementSecondaryCollectionReport,
    loading,
    MSWManagementSecondaryCollectionReportData,
  } = MSWManagementSecondaryCollectionStore();

  const navigate = useNavigate();

  // State to store filter dates
  const [filterDates, setFilterDates] = useState('');
  

  useEffect(() => {
    // Get stored filters from localStorage
    const storedFilters = localStorage.getItem("mswSecondaryCollectionFilters");
    console.log(storedFilters)
    if (storedFilters) {
      const parsedFilters = JSON.parse(storedFilters);
      setFilterDates({
        parsedFilters
      });
      fetchMSWManagementSecondaryCollectionReport(parsedFilters);
    }
  }, []);

  console.log(filterDates)

  // Format date as dd/mm/yyyy - HH:mm
  const formatDateTime = (dateString) => {
    if (!dateString) return "-";
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    return `${day}/${month}/${year} - ${hours}:${minutes}`;
  };
 const formattedDateForBE = (dateString) => {
  const dateOnly = dateString?.split('T')[0];
  const [year, month, day] = dateOnly?.split('-');
  return `${year}-${month}-${day}`;
};
  const mswSecondaryCollectionReportHeaderColumns = [
    {
      label: "Date",
      field: "reportDate",
      render: (row) => {
        if (row.reportDate === "Total") return <strong>Total</strong>;
        const date = new Date(row.reportDate);
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();
        return (
          <div
            style={{
              cursor: "pointer",
              color: "blue",
              fontWeight: "normal",
            }}
            onClick={() => {

               localStorage.setItem("MSWManagementVehiclesDate", JSON.stringify(formattedDateForBE(row.reportDate)));

              navigate("/msw-management-vehicles-inner-report", {
                state: { reportDate: row.reportDate },
              });
            }}
          >
            {`${day}-${month}-${year}`}
          </div>
        );
      },
    },
    {
      label: <>Total Number Of Vehicles<br /> Planned For Deployment (a)</>,
      field: "plannedVehicleCount",
      render: (row) => {
        // If value is null/undefined/empty string, show 0
        return row.plannedVehicleCount ?? 0;
      },
    },
    {
      label: <>Total Number Of<br /> Vehicles Deployed (b)</>,
      field: "deployedVehicleCount",
      render: (row) => {
        return row.deployedVehicleCount ?? 0;
      },
    },
    {
      label: "Performance Achieved",
      field: "performanceAchieved",
    },
    {
      label: "Remarks",
      field: "remarks",
    },
  ];
  

  return (
    <div>
      <div className="card mt-3">
        <div>
        

          <MSWManagementVehiclesFilter />

          {/* <MSWManagementVehiclesExport
            data={MSWManagementSecondaryCollectionReportData}
            fromDate={filterDates.fromDate}
            toDate={filterDates.toDate}
          /> */}

          {loading ? (
            <TableSkeleton />
          ) : (
            <MUITable
              hasTotalRow={true}
              needSRNumber
              columns={mswSecondaryCollectionReportHeaderColumns}
              rows={MSWManagementSecondaryCollectionReportData}
              tableHeight={500}
            />
          )}
        </div>
      </div>
    </div>
  );
};
